// Blobs de adjuntos con formato nuevo: {workspace}/email/{templates|<id>/(inbound|outbound)}/{uuid hex}_{nombre}
// Los adjuntos antiguos se guardaban en la raíz del bucket sin prefijo, por eso solo se limpia este formato.
const PREFIXED_BLOB_REGEX =
  /\/email\/(?:templates|\d+\/(?:inbound|outbound))\/[0-9a-f]{32}_([^/]+)$/i;

const safeDecode = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/** Nombre original del adjunto a partir de su URL pública, sin el prefijo uuid del bucket. */
export const getAttachmentFileName = (url: string): string => {
  if (!url) return "";

  const path = url.split(/[?#]/)[0];
  const segment = path.split("/").pop() || "";
  const originalName = path.match(PREFIXED_BLOB_REGEX)?.[1];

  return safeDecode(originalName || segment);
};
